export interface SignupDraft {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  country_code?: string;
}

const DRAFT_KEY = "signup_draft";

export const getSignupDraft = (): SignupDraft => {
  try {
    const sessionVal = sessionStorage.getItem(DRAFT_KEY);
    if (sessionVal) {
      const parsed = JSON.parse(sessionVal);
      if (parsed && typeof parsed === "object") {
        return {
          first_name: parsed.first_name || "",
          last_name: parsed.last_name || "",
          email: parsed.email || "",
          phone_number: parsed.phone_number || "",
          country_code: parsed.country_code || "",
        };
      }
    }
  } catch (e) {}

  try {
    const localVal = localStorage.getItem(DRAFT_KEY);
    if (localVal) {
      const parsed = JSON.parse(localVal);
      if (parsed && typeof parsed === "object") {
        return {
          first_name: parsed.first_name || "",
          last_name: parsed.last_name || "",
          email: parsed.email || "",
          phone_number: parsed.phone_number || "",
          country_code: parsed.country_code || "",
        };
      }
    }
  } catch (e) {}

  return {};
};

export const setSignupDraft = (data: SignupDraft): void => {
  // Only persist non-sensitive information; NEVER persist passwords in localStorage/sessionStorage
  const nonSensitiveDraft: SignupDraft = {
    first_name: data.first_name || "",
    last_name: data.last_name || "",
    email: data.email || "",
    phone_number: data.phone_number || "",
    country_code: data.country_code || "",
  };

  const json = JSON.stringify(nonSensitiveDraft);
  try {
    sessionStorage.setItem(DRAFT_KEY, json);
  } catch (e) {}
  try {
    localStorage.setItem(DRAFT_KEY, json);
  } catch (e) {}
};

export const clearSignupDraft = (): void => {
  try {
    sessionStorage.removeItem(DRAFT_KEY);
  } catch (e) {}
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch (e) {}
};
